<template>
  <div>
    <quiz-content v-for="(qm, qmIndex) in limitedQmList" :key="`quiz_content_${qmIndex}`">
      <div class="quiz_header">
        <quiz-header-text>正解で{{qm.point}}pt GET!</quiz-header-text>
        <quiz-release-date :timestamp="qm.start_datetime"/>
      </div>
      <quiz-body>
        <quiz-question-image :qm_id="qm.id"/>
        <quiz-question>
          <quiz-text :text="qm.quiz_text"/>
          <quiz-button :hint_url="qm.hint_url" text="ヒントはこちら" @clickQuizButton="clickQuizButtonHandler(qm.id)"/>
        </quiz-question>
        <div class="quiz_selection">
          <div v-for="(qsm, qsmKey, qsmIndex) in qsm_lists[qm.quiz_selections_masters_group_id]"
               :key="`quiz_selection_${qsmKey}_${qsmKey}`">
            <button v-if="qsmIndex === 0" class="selection_bt selection1" disabled><span>{{qsm.selection}}</span></button>
            <button v-if="qsmIndex === 1" class="selection_bt selection2" disabled><span>{{qsm.selection}}</span></button>
            <button v-if="qsmIndex === 2" class="selection_bt selection3" disabled><span>{{qsm.selection}}</span></button>
          </div>
        </div>
        <quiz-term :limited_flag="qm.limited_flag" :timestamp="qm.end_datetime"/>
      </quiz-body>
    </quiz-content>
  </div>
</template>

<script>
import AnsweredListable from '@/components/mixins/AnsweredListable'
import HintClickable from '@/components/mixins/HintClickable'

export default {
  name: 'BeforeLoginUnansweredList',
  mixins: [AnsweredListable, HintClickable]
}
</script>

<style scoped>
  .quiz_header {
    height: 70px;
    color: #fff;
    background: #ec8dae;
    border-radius: 48px 0 0 0;
    position: relative;
  }

  @media screen and (max-width: 767px) {
    .quiz_header {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  }

  .quiz_header::before {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 3px;
    content: "";
    background: url("../assets/quiz_plt_deco00_white.png") no-repeat center bottom;
  }

  @media screen and (max-width: 767px) {
    .quiz_header::before {
      background: url("../assets/quiz_plt_deco00_white_sp.png") no-repeat center bottom;
      background-size: 100%;
    }
  }

  .quiz_selection {
    width: 100%;
    height: 102px;
    margin-top: 23px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-justify-content: space-around;
    justify-content: space-around;
  }

  @media screen and (max-width: 767px) {
    .quiz_selection {
      height: auto;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
    }
  }

  @media screen and (max-width: 767px) {
    .quiz_selection > div {
      width: 100%;
    }
  }

  .selection_bt {
    border: none;
    outline: none;
    appearance: none;
    width: 252px;
    height: 102px;
    margin: 20px auto;
    padding: 17px 40px 3px 45px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #676767;
    font-size: 18px;
    line-height: 18px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
  }

  @media screen and (max-width: 767px) {
    .selection_bt {
      width: 100%;
      height: 102px;
      position: relative;
      padding: 3px 40px 3px 55px;
    }
  }

  @media screen and (max-width: 767px) {
    .selection_bt:before {
      background: #ec8dae;
      border-radius: 25px;
      background-size: contain;
      width: 50px;
      height: 50px;
      color: #fff;
      font-size: 30px;
      position: absolute;
      left: 2px;
      top: 0;
      bottom: 0;
      margin: auto 0;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      line-height: 30px;
    }
  }
  @media screen and (max-width: 767px) {
    .selection_bt:disabled:before {
      background: #b9b9b9;
    }
  }
  @media screen and (max-width: 767px) {
    .selection_bt:disabled:after {
      background: none;
    }
  }
  @media screen and (max-width: 767px) {
    .selection1.selection_bt:before {
      content: "A";
    }
  }
  @media screen and (max-width: 767px) {
    .selection2.selection_bt:before {
      content: "B";
    }
  }
  @media screen and (max-width: 767px) {
    .selection3.selection_bt:before {
      content: "C";
    }
  }

  @media screen and (max-width: 767px) {
    .selection_bt:after {
      content: "";
      background: url("../assets/quiz_answer_icon_arrow_sp.png") no-repeat center;
      border-radius: 18px;
      background-size: contain;
      width: 30px;
      height: 30px;
      position: absolute;
      right: 10px;
      top: 0;
      bottom: 0;
      margin: auto 0;
    }
  }

  .selection_bt:disabled {
    cursor: default;
    pointer-events: none;
  }

  .selection1.selection_bt {
    background: url("../assets/quiz_answer_btn_base_a.png") no-repeat center;
  }

  .selection1.selection_bt:hover {
    background: url("../assets/quiz_answer_btn_mouseover_a.png") no-repeat center;
  }

  .selection1.selection_bt:disabled {
    background: url("../assets/quiz_answer_btn_glay_a.png") no-repeat center;
  }

  .selection2.selection_bt {
    background: url("../assets/quiz_answer_btn_base_b.png") no-repeat center;
  }

  .selection2.selection_bt:hover {
    background: url("../assets/quiz_answer_btn_mouseover_b.png") no-repeat center;
  }

  .selection2.selection_bt:disabled {
    background: url("../assets/quiz_answer_btn_glay_b.png") no-repeat center;
  }

  .selection3.selection_bt {
    background: url("../assets/quiz_answer_btn_base_c.png") no-repeat center;
  }

  .selection3.selection_bt:hover {
    background: url("../assets/quiz_answer_btn_mouseover_c.png") no-repeat center;
  }

  .selection3.selection_bt:disabled {
    background: url("../assets/quiz_answer_btn_glay_c.png") no-repeat center;
  }

  @media screen and (max-width: 767px) {
    .selection1.selection_bt , .selection2.selection_bt , .selection3.selection_bt {
      background: #fff;
      border-radius: 5px;
      border: 2px solid #ec8dae;
    }
  }
  @media screen and (max-width: 767px) {
    .selection1.selection_bt:hover , .selection2.selection_bt:hover , .selection3.selection_bt:hover {
      background: #fbe8ee;
    }
  }
  @media screen and (max-width: 767px) {
    .selection1.selection_bt:disabled , .selection2.selection_bt:disabled , .selection3.selection_bt:disabled {
      background: #e8e8e8;
      border: 2px solid #b9b9b9;
    }
  }
</style>
